import { useGoals } from 'features/goals';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useFilteredGoals = () => {
  const user = useUser();
  const goals = useGoals();

  return useMemo(() => {
    const roadmapSettings = user?.settings?.goalsOverview?.roadmap ?? {};
    if (
      !roadmapSettings.hideUnplannedGoals &&
      !roadmapSettings.hideCompletedGoals &&
      !roadmapSettings.hideArchivedGoals
    ) {
      return goals;
    }

    return goals.filter((goal) => {
      if (
        roadmapSettings.hideUnplannedGoals &&
        (!goal.startDate || !goal.deadline)
      ) {
        return false;
      }

      if (roadmapSettings.hideCompletedGoals && !!goal.completedAt) {
        return false;
      }

      return !(roadmapSettings.hideArchivedGoals && !!goal.archivedAt);
    });
  }, [goals, user?.settings?.goalsOverview?.roadmap]);
};
